import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import { SwitchUserRoleMenuItem } from 'containers/Header/components/SwitchUserRoleMenuItem';
import { AvatarButton } from 'containers/Header/components/AvatarButton';
import { LogoutMenuItem } from 'containers/Header/components/LogoutMenuItem';
import { MenuItems } from 'containers/Header/components/MenuItems';
import { PlanInfoMenuItem } from 'containers/Header/components/PlanInfoMenuItem';
import React from 'react';
import {
  contactUs,
  documentation,
  MenuItem,
  news,
  parrainage,
  reglageMenuItem,
  shareIdeas,
  souscription,
  tarifsMenuItem,
} from '@teetsh/app/src/containers/Header/menus';
import { PremiumButton } from '@teetsh/app/src/components/Buttons/PremiumButton';
import { Menu } from '@teetsh/app/src/components/Menu';
import 'twin.macro';
import { useUserAccount } from '@teetsh/app/src/queries/user/account/useUserAccount';
import { UserAccount } from '@teetsh/app/src/types/user';

interface Props {
  userAccount?: UserAccount;
  noPremiumButton?: boolean;
  large?: boolean;
}

export function UserProfileButton(props: Props) {
  const { isLoading, data } = useUserAccount(!!props.userAccount);
  const userAccount = props.userAccount || data;
  const user = useUser();

  const baseMenu = [
    reglageMenuItem,
    parrainage,
    documentation,
    souscription,
    contactUs,
    shareIdeas,
    news,
  ];

  if (isLoading || !userAccount || !user) {
    return <div tw="h-10 w-48 rounded-lg" className="tsh-skeleton" />;
  }

  const menuItems: MenuItem[] = userAccount?.isOnFreePlan
    ? [...baseMenu, tarifsMenuItem]
    : baseMenu;

  return (
    <div tw="flex items-center shrink-0">
      {userAccount.isOnFreePlan && !props.noPremiumButton && (
        <PremiumButton outlined large={props.large} />
      )}
      <Menu>
        <AvatarButton userAccount={userAccount} large={props.large} />
        <Menu.Items tw="w-auto min-w-[16rem]">
          <PlanInfoMenuItem userAccount={userAccount} />
          <div>
            <MenuItems items={menuItems} />
            <LogoutMenuItem />
          </div>
          <div>
            <SwitchUserRoleMenuItem />
          </div>
        </Menu.Items>
      </Menu>
    </div>
  );
}
